import React from "react";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { colors } from "@material-ui/core";
import { styleNo } from "../../../Invs/ShareFunctionsPrint";
import { useTranslation } from "react-i18next";

export function TotalsRestriction(props) {
  const cls = useRptAF();
  const {infoData}=props;
  return (

    <Grid
    container
    lg={12}
    md={12}
    
    style={{paddingTop:"0.5rem",paddingBottom:"0.5rem", backgroundColor: colors.grey[100],fontFamily: "Amiri-Regular"  }}
  >
    <Grid container xs={12} /*className={cls.rootchip}*/  style={{ paddingBottom: 5, 
      backgroundColor: colors.grey[100],fontFamily: "Amiri-Regular",
      border: "solid 1px",
      padding: "0.3rem 0.1rem 0.3rem 0.1rem", 
      borderRadius: "0px 0px 5px 0px" }}>
           <Grid item xs={3} className={[cls.chipVMU]}></Grid>

      <Grid item xs={2} className={[cls.chipVMU]}>
        {parseFloat(infoData.total_dept)?.toFixed(2)}
      </Grid>
      <Grid item xs={2} className={[cls.chipVMU]}>
        {parseFloat(infoData.total_credit)?.toFixed(2)}
      </Grid>
      <Grid item xs={4} className={[cls.chipTMU]} >
        {"الاجمالي"}
      </Grid>
    </Grid>
  </Grid>
  );
}
function BodyRest({ data }) {
  const cellS = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    width: "33%",
    fontFamily: "Amiri-Regular",
    fontWeight:"bold",
  };
  const { t } = useTranslation(["forms"]);

  var columns = [
    { title: "كود الحساب", field: "acc_no",cellStyle:{...styleNo,width:"8%"}},
    { title: "اسم الحساب", field: "name" ,cellStyle:{...cellS,width:"30%"}},
    { title: "مدين", field: "dept" ,},
    { title: "دائن", field: "credit" ,},
    { title: t("ref-no"), field: "ref_no" ,},
    {
      title: "البيان",
      field: "notes",
      cellStyle: cellS
    },
  ];

  const data2 = data.map((row) => {
    return {
      ...row,
      dept: parseFloat(row.dept)?.toFixed(2),
      credit: parseFloat(row.credit)?.toFixed(2),
    };
  });
  return (
    <Grid item container style={{fontFamily: "Amiri-Regular"}}>
      <Grid item container style={{ direction: "rtl",paddingTop:"0.7rem"}}>
        <Grid
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none",width:"100%" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom:"2px",
                border: "solid 0px",
                border: "solid 0.1px",
               
                
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={columns}
            data={data2}
          />
        </Grid>
      </Grid>

    </Grid>
  );
}

export default BodyRest;
